import { ReactNode } from 'react';

interface StackedLayoutProps {
  navbar: ReactNode;
  sidebar: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * StackedLayout component - provides a stacked layout structure
 * with a navbar for desktop and sidebar for mobile navigation
 */
export function StackedLayout({ navbar, sidebar, children, footer }: StackedLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Mobile sidebar */}
      <div className="lg:hidden">{sidebar}</div>

      {/* Desktop navbar */}
      <div className="lg:block">{navbar}</div>

      {/* Main content */}
      <main className="lg:pl-0 flex-1">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">{children}</div>
      </main>

      {/* Footer */}
      {footer && <div className="mt-auto">{footer}</div>}
    </div>
  );
}
